export default class AgreeCheck {
  constructor(check){
    this.$ = check;
    this.wrapper = this.$.closest('.js-agreecheck');
    this.btn = this.wrapper.querySelector('.js-agreecheck-btn');
    this.initialize();
    this.bind();
  }

  initialize() {
    this.ableToggle();
  }

  bind() {
    this.$.addEventListener('change', this.ableToggle.bind(this));
  }

  ableToggle(){
    if(this.$.checked){
      this.btn.removeAttribute('disabled');
      this.btn.style.pointerEvents = 'unset';
    }else{
      this.btn.setAttribute('disabled','disabled');
      this.btn.style.pointerEvents = 'none';
    }
  }

}
